module.exports = __webpack_public_path__ + "img/tag-specialMember.b9508d63.svg";